import React, {useMemo} from 'react';
import {Alert, Space, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons/lib";
import {useRequest} from "ahooks";
import {isRunningImport, ITagLog} from "../../types/tag";
import npiApi from "../../services/api";
import {TagLogStatus} from "../../containers/dev-dashboard/tag-import-logs";

interface TagImportInfosProps {
    filename: string|null
    waveId?: number
}

const TagImportInfos = (props: TagImportInfosProps) => {
    const {filename, waveId} = props;

    const {loading, data:logs, run: runList} = useRequest<ITagLog[], any>(npiApi.internal.dev.tagUpload.logs);
    const {data:fetchLog, run: runDetail, mutate: setFetchLog} = useRequest<ITagLog, any>(npiApi.internal.dev.tagUpload.log, {manual: true});

    // refresh list whenever filename / wave changes
    React.useEffect(() => {
        setFetchLog(undefined as unknown as ITagLog);
        runList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filename]);

    const lastLog = useMemo<ITagLog|null>(() => {
        if(fetchLog) {
            return fetchLog;
        }

        if(!logs || logs.length === 0) return null;
        const filterLogs = logs.filter(l => l.type === "FILE_IMPORT");

        if(filename) {
            return filterLogs.find(l => waveId ? (l.original_filename === filename && l.wave_id === waveId) : (l.original_filename === filename && !l.wave_id)) ?? null;
        }

        return filterLogs.filter(l => waveId ? (l.wave_id === waveId) : !l.wave_id)[0] ?? null;
    }, [logs, filename, waveId, fetchLog])


    // Auto-refresh every 3s while modal is open
    const pollRef = React.useRef<ReturnType<typeof setInterval> | null>(null);
    const doneForIdRef = React.useRef<number | null>(null);
    React.useEffect(() => {
        // clear previous poller
        if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
        }

        if (!lastLog) return;

        // if terminal now
        if (!isRunningImport(lastLog)) {
            if (doneForIdRef.current !== lastLog.id) {
                doneForIdRef.current = lastLog.id;
            }
            return;
        }

        // running → fetch once immediately, then poll
        pollRef.current = setInterval(() => {
            runDetail(lastLog.id)
        }, 3000);

        return () => {
            if (pollRef.current) {
                clearInterval(pollRef.current);
                pollRef.current = null;
            }
        };
    }, [lastLog, runDetail]);


    // if(!lastLog) {
    if(!lastLog && !loading) {
        return null;
    }

    if(lastLog) {
        return <Alert
            style={{position: "fixed", bottom: 0, right: 0, maxWidth: 380, fontSize: 13}}
            message={<Space direction="vertical" size={0} style={{marginLeft: 10}}>
                <Space><strong>Latest Tag file</strong> {waveId && <em>#wave {waveId}</em>} <TagLogStatus status={lastLog.status} /></Space>
                <em style={{fontSize: 12}}>{lastLog.started_at}</em>
                <span style={{fontSize: 12}}>{lastLog.original_filename}</span>
            </Space>}
            type="info"
            showIcon={isRunningImport(lastLog)}
            icon={<Spin indicator={<LoadingOutlined spin/>}/>}
            // description={<>
            //     {lastLog.status === "FAILED"
            //         && <><hr/><div dangerouslySetInnerHTML={{__html: lastLog.error?.message ?? "Unknown error"}}></div></>
            //         // : <LogStepsView steps={lastLog.steps ?? []} shortFormat={true} limit={lastLog.status !== "COMPLETED" ? 2 : 1}/>
            //     }
            // </>}
        />
    }

    return <Alert
        style={{position: "fixed", bottom: 0, right: 0, maxWidth: 380, fontSize: 13}}
        message={<strong>Latest Tag file</strong>}
        type="info"
        showIcon
        icon={<Spin indicator={<LoadingOutlined spin/>}/>}
    />
}

export default TagImportInfos;